import React from 'react'
import {
  TextField
} from '@material-ui/core';

const Footer = ({footer, handleChange}) => {
  return (
    <TextField  label="Saludo final"
      variant="outlined"
      name={'footer'}
      multiline
      fullWidth
      margin={'normal'}
      value={footer || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default Footer
